module.exports = __webpack_public_path__ + "b33ee183be99c2571a985dbcb8edb8bd.svg";